import { create } from "zustand";
import {
  TGlobalStore,
  TGlobalStoreMethods,
} from "src/shared/types/globalStotre.types";

export const useGlobalStore = create<TGlobalStore & TGlobalStoreMethods>(
  (set) => {
    return {
      passes: [],
      events: [],
      session: null,
      cart: { passes: [], products: [], reservations: [] },
      groupDetails: null,
      invitationGroupDetails: null,
      tempOAuthAccount: null,
      oAuthState: null,
      user: null,
      passesOnAccount: [],
      purchaseHistory: null,
      marketplacePurchaseHistory: null,
      eventActivityHistory: [],
      subscriptionDetails: [],
      savedCard: null,
      reward: null,
      mlbBallparkUser: null,
      additionalDetails: [],
      swafConfig: null,
      passBundles: [],
      optedInCountForEventReservation: null,
      reservationLimitsByPass: null,
      attribution: { infoFields: [], repAccountId: "" },
      // methods
      setGlobalState: (newState: Partial<TGlobalStore>) => set(newState),
    };
  }
);
